module.exports = __webpack_public_path__ + "img/yellow_marker3.d35268a4.svg";